export default __webpack_public_path__ + "static/1-0_HSR_Icon-b5713c8b6e7e5ab95386fc32a94b3ce6.png";